"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safari = exports.ie11 = exports.firefox = exports.edgeUWP = exports.edgeAnaheim = exports.chromium = exports.chrome = void 0;
var _navigator = navigator,
    userAgent = _navigator.userAgent; // not DRY so that list can be alphabetical

var chromium = !/Edge\//.test(userAgent) && /Chrome\//.test(userAgent);
exports.chromium = chromium;
var edgeAnaheim = /Edg\//.test(userAgent);
exports.edgeAnaheim = edgeAnaheim;
var edgeUWP = /Edge\//.test(userAgent);
exports.edgeUWP = edgeUWP;
var firefox = /Firefox\//.test(userAgent);
exports.firefox = firefox;
var ie11 = /Trident\/7(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])0/.test(userAgent);
exports.ie11 = ie11;
var chrome = chromium && !edgeAnaheim;
exports.chrome = chrome;
var safari = !(chrome || edgeUWP || ie11 || firefox);
exports.safari = safari;